export const defaultTheme = {
  light: { primary: '#3F51B5', secondary: '#607D8B', accent: '#FF4081', success: '#4CAF50', warning: '#FB8C00', error: '#FF5252', info: '#2196F3' },
  dark: { primary: '#7986CB', secondary: '#90A4AE', accent: '#FF80AB', success: '#66BB6A', warning: '#FFA726', error: '#FF5252', info: '#42A5F5' },
  surfaces: {
    page: '#F5F6FA', tabs: '#FFFFFF', tabsText: '#4A4A4A', tabsActive: '#3F51B5', tabsActiveBackground: '#F0F1FA', tabsContent: '#FFFFFF', card: '#FFFFFF', toolbar: '#FAFBFE',
    navigation: '#1A237E', navigationAccent: '#1565C0', navigationDrawer: '#FFFFFF', navigationDrawerActive: '#E8EAF6',
    table: '#FFFFFF', tableAlternate: '#F8F8F8', tableHeader: '#F1F3F8', formButton: '#3F51B5',
    modalHeaderStart: '#FFFFFF', modalHeaderEnd: '#ADADAD',
    chatRail: '#FFFFFF', chatRailActive: '#EDF0FB', chatModal: '#FFFFFF', chatSidebar: '#FAFBFE', chatSidebarActive: '#E9EDF9',
    chatConversation: '#F2F4F8', chatHeader: '#FFFFFF', chatComposer: '#FFFFFF', chatMessageOwn: '#E3E9FC', chatMessageOther: '#FFFFFF',
    chatText: '#26334A', chatMuted: '#737F94',
    chatResourceCard: '#FFFFFF', chatResourceViewer: '#F5F6FA', chatResourceHeader: '#FAFBFE',
    guideBackground: '#FFFFFF', guideText: '#334155', guideTitle: '#172554', guideBorder: '#E2E8F0',
    guidePrimary: '#4F46E5', guidePrimaryText: '#FFFFFF', guideSecondary: '#EEF2FF', guideSecondaryText: '#3730A3',
    guideOverlay: '#111827', guideProgress: '#6366F1', guidePositive: '#16A34A', guideNegative: '#DC2626',
  },
  darkSurfaces: {
    page: '#121212', tabs: '#1E1E1E', tabsText: '#D0D0D0', tabsActive: '#9FA8DA', tabsActiveBackground: '#292C3D', tabsContent: '#1E1E1E', card: '#1E1E1E', toolbar: '#252525',
    navigation: '#111827', navigationAccent: '#312E81', navigationDrawer: '#1E1E1E', navigationDrawerActive: '#30334A',
    table: '#1E1E1E', tableAlternate: '#252525', tableHeader: '#303030', formButton: '#7986CB',
    modalHeaderStart: '#252525', modalHeaderEnd: '#424242',
    chatRail: '#202737', chatRailActive: '#303B53', chatModal: '#1C2331', chatSidebar: '#202737', chatSidebarActive: '#303B53',
    chatConversation: '#171E2B', chatHeader: '#202737', chatComposer: '#202737', chatMessageOwn: '#33446B', chatMessageOther: '#263044',
    chatText: '#E2E7EF', chatMuted: '#A5AFC0',
    chatResourceCard: '#263044', chatResourceViewer: '#171E2B', chatResourceHeader: '#202737',
    guideBackground: '#202737', guideText: '#E2E8F0', guideTitle: '#E0E7FF', guideBorder: '#3B4860',
    guidePrimary: '#818CF8', guidePrimaryText: '#111827', guideSecondary: '#303B53', guideSecondaryText: '#E0E7FF',
    guideOverlay: '#020617', guideProgress: '#A5B4FC', guidePositive: '#4ADE80', guideNegative: '#F87171',
  },
}

export const normalizeTheme = theme => {
  const source = theme && !Array.isArray(theme) ? theme : {}
  return {
    light: { ...defaultTheme.light, ...(source.light || {}) },
    dark: { ...defaultTheme.dark, ...(source.dark || {}) },
    surfaces: { ...defaultTheme.surfaces, ...(source.surfaces || {}) },
    darkSurfaces: { ...defaultTheme.darkSurfaces, ...(source.darkSurfaces || {}) },
  }
}

export const applyTheme = (vuetify, theme, dark = false) => {
  if (!vuetify || !vuetify.theme) return
  const normalized = normalizeTheme(theme)
  Object.assign(vuetify.theme.themes.light, normalized.light)
  Object.assign(vuetify.theme.themes.dark, normalized.dark)
  vuetify.theme.dark = Boolean(dark)

  const root = document.documentElement
  const palette = dark ? normalized.dark : normalized.light
  Object.entries(palette).forEach(([key, value]) => {
    root.style.setProperty(`--app-${key}`, value)
  })
  const surfaces = dark ? normalized.darkSurfaces : normalized.surfaces
  Object.entries(surfaces).forEach(([key, value]) => {
    const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase()
    root.style.setProperty(`--app-${cssKey}`, value)
  })
}
